module.exports = __webpack_public_path__ + "img/water-loading.4c5d147e.webp";